import { PopupBackground } from "@/common/popups/common/popup-background";
import { PopupContent } from "@/common/popups/common/popup-content";
import React from "react";

export const PopupEmoj = React.memo(function PopupEmoj(props: {
  title?: React.ReactNode;
  className?: string;
  emoj?: string;
  image?: string;
  sentence?: string;
  inlineStyle?: React.CSSProperties;
  children?: React.ReactNode;
}) {
  return (
    <PopupBackground
      title={props.title}
      className={props.className}
      inlineStyle={props.inlineStyle}
    >
      <PopupContent {...props}>{props.children}</PopupContent>
    </PopupBackground>
  );
});
